import sogradAvatar from '~/features/chatbot/assets/sograd-avatar.png';

export const CHATBOT_CONFIG = {
    /** Display name shown in the sidebar header */
    headerTitle: 'MDM OTA Assistant',
    /** Display name shown inside conversations (message bubbles, etc.) */
    name: 'Sograd',
    avatar: sogradAvatar,
};
